import { Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { white } from '@styles/colors';
import React, { FC } from 'react';
import CloseIcon from '@mui/icons-material/Close';

type ShowVerifiedFirestModalProps = {
  showVerifiedFirstModal: Boolean;
  handleClose: () => void;
};

const ShowVerifiedFirestModal: FC<ShowVerifiedFirestModalProps> = ({
  showVerifiedFirstModal,
  handleClose,
}) => {
  return (
    <Dialog
      open
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      disableEnforceFocus
    >
      <DialogTitle>
        <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ bgcolor: white }}>
        <Grid>
          <img
            width="100%"
            height="auto"
            src="https://s3.amazonaws.com/vf.public.bucket/integration_logos/dd3ce159-5f73-dd1d-953c-25aa384673ac.png?time=1713784496651"
          />
        </Grid>
        <Grid>
          <Stack
            spacing={4}
            direction={{ sm: 'column' }}
            justifyContent="center"
            alignItems="center"
          >
            <Grid>
              <Stack
                direction={{ sm: 'column' }}
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="h6">You are not logged into</Typography>
                <Typography sx={{ fontWeight: 'bold', mb: 2 }} variant="h6">
                  Staffed Up × VerifiedFirst
                </Typography>
              </Stack>
            </Grid>
            <Button
              variant="outlined"
              size="small"
              color="green"
              style={{ borderRadius: '6px' }}
            >
              <Typography
                fontSize="18px"
                component="span"
                lineHeight="1.1"
                sx={{ maxWidth: '50px', ml: 7, mr: 7, mt: 2, mb: 2 }}
              >
                Login
              </Typography>
            </Button>
            <Button
              variant="contained"
              size="small"
              color="green"
              style={{ borderRadius: '6px' }}
            >
              <Typography
                fontSize="18px"
                component="span"
                lineHeight="1.1"
                sx={{ maxWidth: '50px', ml: 7, mr: 7, mt: 2, mb: 2 }}
                onClick={() =>
                  window.open(
                    'https://www.verifiedfirst.com/get-a-background-screening-quote.html',
                    '_blank',
                  )
                }
              >
                Signup
              </Typography>
            </Button>
            <Grid container>
              <Typography
                sx={{ fontSize: '10px', fontWeight: 'bold' }}
                variant="subtitle2"
              >
                NOTICE:&nbsp;
                <Typography
                  variant="subtitle2"
                  component="span"
                  sx={{ fontSize: '10px' }}
                >
                  The use of this system is restricted. Only authorized users
                  may access this system. All Access to this system is logged
                  and regularly monitored for computer security purposes. Any
                  unauthorized access to this system is prohibited and is
                  subject to criminal and civil penalties under Federal Laws
                  including, but not limited to, the Computer Fraud and Abuse
                  Act and the National Information Infrastructure Protection
                  Act.
                </Typography>
              </Typography>
            </Grid>
          </Stack>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ShowVerifiedFirestModal;
